module.exports = __webpack_public_path__ + "img/logo.695e4d99.png";